import { nav } from './en/nav';
import { home } from './en/home';
import { vps } from './en/vps';
import { dedicated } from './en/dedicated';
import { gameHosting } from './en/gameHosting';
import { webHosting } from './en/webHosting';
import { ipTransit } from './en/ipTransit';
import { colocation } from './en/colocation';
import { network } from './en/network';
import { contact } from './en/contact';
import { common } from './en/common';
import { legal } from './en/legal';
import { faq } from './en/faq';
import { datacenters } from './en/datacenters';
import { abuse } from './en/abuse';

export const en = {
  nav,
  home,
  vps,
  dedicated,
  gameHosting,
  webHosting,
  ipTransit,
  colocation,
  network,
  contact,
  common,
  legal,
  faq,
  datacenters,
  abuse
};